'use client';

import type { FC } from 'react';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './LoadingSpinner.translations';
import { Spinner, Text } from './ui';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ message, size = 'medium' }) => {
  const { t } = useLocalTranslation(translations);
  const displayMessage = message ?? t('loading');
  const spinnerSize = size === 'small' ? 's' : size === 'large' ? 'l' : 'm';

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-4">
      <Spinner size={spinnerSize} />
      <Text weight="2" className="m-0 text-white text-base">
        {displayMessage}
      </Text>
    </div>
  );
};
